import './style.css';
import { calculateTaxFromCents, solveNetToGross, S1, S2 } from './taxCalculator';

const $ = <T extends HTMLElement>(id: string) => document.getElementById(id) as T | null;
const fmt = (n: number) => n.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });

function render() {
  const netInput = $<HTMLInputElement>('net');
  const yearSelect = $<HTMLSelectElement>('year');
  const tftSelect = $<HTMLSelectElement>('tft');
  const supInput = $<HTMLInputElement>('sup');
  const outDiv = $('out');

  if (!netInput || !yearSelect || !tftSelect || !supInput || !outDiv) return;

  const selectedYear = yearSelect.value;

  if (selectedYear === '2027-2028') {
    outDiv.innerHTML = `
      <div class="warn-card">
        <strong>Tax Year 2027–2028 Not Available</strong><br />
        The tax tables for the 2027–2028 financial year have not been released by the ATO yet. This tool needs updating once the ATO publishes the 2027–2028 monthly tax tables (NAT 1007).
      </div>
    `;
    return;
  }

  const rawVal = netInput.value.trim();
  if (rawVal === '') {
    outDiv.innerHTML = `
      <div class="card">
        <div class="note" style="margin-top:0; font-size:14px; color: var(--mut);">
          Enter a monthly net pay amount above to calculate gross pay, tax withheld, and super guarantee.
        </div>
      </div>
    `;
    return;
  }

  const v = parseFloat(rawVal);
  if (!(v >= 0)) {
    outDiv.innerHTML = '<div class="card">Enter a valid positive net amount.</div>';
    return;
  }

  const s = parseFloat(supInput.value);
  const yes = tftSelect.value === '1';

  const netC = Math.round(v * 100);
  const supR = Number.isFinite(s) ? s : 0;
  const scale = yes ? S2 : S1;

  const { hits, best } = solveNetToGross(netC, scale);
  const opts = hits.length ? hits : [best.T];
  const T = opts[opts.length - 1]; // Highest matching tax/gross

  const gC = netC + T * 100;
  const g = gC / 100;
  const sup = (g * supR) / 100;
  const taxWithheld = calculateTaxFromCents(gC, scale);

  const title = yes ? 'With Tax-Free Threshold Claimed' : 'No Tax-Free Threshold Claimed';
  let note = '';
  if (!hits.length) {
    note = '<div class="note warn">Exact net not attainable; nearest dollar fallback shown.</div>';
  }

  outDiv.innerHTML = `
    <div class="card">
      <h2>${title}</h2>
      <div class="r"><span>Gross pay</span><b class="big">${fmt(g)}</b></div>
      <div class="r"><span>Tax withheld</span><b>${fmt(taxWithheld)}</b></div>
      <div class="r"><span>Net pay</span><b>${fmt(g - taxWithheld)}</b></div>
      <div class="r"><span>Super (${supR}%)</span><b>${fmt(sup)}</b></div>
      <div class="r"><span>Gross + super</span><b>${fmt(g + sup)}</b></div>
      ${note}
    </div>
  `;
}

document.addEventListener('DOMContentLoaded', () => {
  const netInput = $('net');
  const yearSelect = $('year');
  const tftSelect = $('tft');
  const supInput = $('sup');

  netInput?.addEventListener('input', render);
  yearSelect?.addEventListener('change', render);
  tftSelect?.addEventListener('change', render);
  supInput?.addEventListener('input', render);

  render();
});
